import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-slot",
  "use": "icon-slot-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-slot\"><path fill=\"#ffffff\" d=\"M98.4 97.18V923h825.87V97.18zM852.27 851H170.4V169.18h681.87zM450.94 717.39h-93.32l140.65-140.65-50.91-50.91-142.82 142.82v-94.81h-72v215.55h218.4v-72zM579.1 494.91l143.39-143.39v93.98h72V225.62H576.63v72h97.93L528.19 444l50.91 50.91z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol